import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstant } from '../../utilities/app.constant';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../../../../assets/styles/share/_footer.scss'],
    standalone: true,
})
export class FooterComponent implements OnInit {
  constructor(
    private _router: Router,
  ) {}

  currentYear = new Date().getFullYear();

  ngOnInit() {}

  redirectToPage(type: string) {
    switch (type) {
      case 'EMPLOYEE_PRIVACY_NOTICE': {
        window.open(
          AppConstant.HALLIBURTON_POLICY_PAGE,
          '_blank' // <- This is what makes it open in a new window.
        );

        break;
      }
      case 'TERMS_OF_USE': {
        this._router.navigate(['/help-center'], { queryParams: { tab: 'term' } });
      }
    }
  }
}
